import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// If path is already an absolute URL (http/https), return it as-is.
// Otherwise resolve it via the backend files proxy.
export const fileUrl = (path) => {
  if (!path) return "";
  if (typeof path === "string" && /^https?:\/\//i.test(path)) return path;
  return `${API}/files/${path}`;
};
